import { useAtom } from 'infrastructure/state/jotai.wrapper'
import { useCallback } from 'react'
import {
  googleUserAtom,
  getDoc,
  getFilesRecursive2,
  GDriveFile,
} from 'infrastructure/googleDrive'
import { getGoogleDriveFolderId } from 'infrastructure/googleDrive/urlParser'

export function useGetAllFiles() {
  const [user, resetUser] = useAtom(googleUserAtom)
  const getFiles = useCallback(
    async (folderId: string): Promise<GDriveFile[]> => {
      if (!user.credential?.accessToken) return []
      try {
        return await getFilesRecursive2(user.credential.accessToken, folderId)
      } catch {
        resetUser()
        return []
      }
    },
    [user, resetUser],
  )
  return {
    getFiles,
    canGetFiles: !!user.credential?.accessToken,
  }
}

export function useGetDoc() {
  const [user, resetUser] = useAtom(googleUserAtom)
  const doGetDoc = useCallback(
    async (folderUrl: string) => {
      const folderId = getGoogleDriveFolderId(folderUrl)
      if (!user.credential?.accessToken) return ''
      try {
        return await getDoc(user.credential.accessToken, folderId)
      } catch {
        resetUser()
        return ''
      }
    },
    [user, resetUser],
  )
  return {
    getDoc: doGetDoc,
    canGetDoc: !!user.credential?.accessToken,
  }
}
